import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import * as ROUTE_TEMPLATES from '../constants/routeTemplates';
import ErrorBoundary from '../components/Error/ErrorBoundary/ErrorBoundary';
import { useRouteTransition } from '../hooks/useRouteTransition';
import OneColumnLayout from '../layouts/OneColumnLayout/OneColumnLayout';
import RouterContextProvider from '../components/Router/RouterContextProvider';
import ScrollRestoration from '../components/ScrollRestoration/ScrollRestoration';
import Search from './pages/AppReviewSearch/AppReviewSearch';
import Favorites from './pages/AppReviewFavorites/AppReviewFavorites';
import AppReviewDashboard from './pages/AppReviewDashboard/AppReviewDashboard';
import GameLaunchReviewMode from '../components/GameLaunch/GameLaunchReviewMode/GameLaunchReviewMode';

const Routes = () => {
  useRouteTransition();

  return (
    <RouterContextProvider>
      <Switch>
        <Route path={ROUTE_TEMPLATES.GAME_DETAIL}>
          <ErrorBoundary>
            <OneColumnLayout>
              <ScrollRestoration>
                <GameLaunchReviewMode />
              </ScrollRestoration>
            </OneColumnLayout>
          </ErrorBoundary>
        </Route>

        <Route
          exact
          path={[
            ROUTE_TEMPLATES.FAVORITES,
            ROUTE_TEMPLATES.SEARCH,
            ROUTE_TEMPLATES.ROOT,
          ]}
        >
          <ErrorBoundary>
            <Switch>
              <Route path={ROUTE_TEMPLATES.SEARCH} exact component={Search} />

              <Route
                path={ROUTE_TEMPLATES.FAVORITES}
                exact
                fallback={() => <Redirect to={ROUTE_TEMPLATES.ROOT} />}
              >
                <Favorites />
              </Route>

              <Route
                path={ROUTE_TEMPLATES.ROOT}
                exact
                component={AppReviewDashboard}
              />
            </Switch>
          </ErrorBoundary>
        </Route>
      </Switch>
    </RouterContextProvider>
  );
};

export default Routes;
